var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_20734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 0.666504H2.66634C1.93301 0.666504 1.33301 1.2665 1.33301 1.99984V10.6665C1.33301 11.0332 1.63301 11.3332 1.99967 11.3332C2.36634 11.3332 2.66634 11.0332 2.66634 10.6665V2.6665C2.66634 2.29984 2.96634 1.99984 3.33301 1.99984H9.99967C10.3663 1.99984 10.6663 1.69984 10.6663 1.33317C10.6663 0.966504 10.3663 0.666504 9.99967 0.666504ZM12.6663 3.33317H5.33301C4.59967 3.33317 3.99967 3.93317 3.99967 4.6665V13.9998C3.99967 14.7332 4.59967 15.3332 5.33301 15.3332H12.6663C13.3997 15.3332 13.9997 14.7332 13.9997 13.9998V4.6665C13.9997 3.93317 13.3997 3.33317 12.6663 3.33317ZM11.9997 13.9998H5.99967C5.63301 13.9998 5.33301 13.6998 5.33301 13.3332V5.33317C5.33301 4.9665 5.63301 4.6665 5.99967 4.6665H11.9997C12.3663 4.6665 12.6663 4.9665 12.6663 5.33317V13.3332C12.6663 13.6998 12.3663 13.9998 11.9997 13.9998Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_20734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.d614da48258cc27afd71ff7e687745ba.svg";
export { ForwardRef as ReactComponent };